import { useMemo } from 'react';
const overrideValues = (values, userValues) => ({
    target: typeof userValues.target === 'string' ? userValues.target : values.target,
    rel: typeof userValues.rel === 'string' ? userValues.rel : values.rel,
});
export const useExternalLink = (options) => {
    const defaultValues = overrideValues({
        target: undefined,
        rel: undefined,
    }, options);
    return useMemo(() => {
        if (!options.href || typeof window === 'undefined') {
            return defaultValues;
        }
        try {
            const url = new URL(options.href);
            if (Boolean(url.hostname) && url.hostname !== window.location.hostname) {
                return overrideValues({
                    target: '_blank',
                    rel: 'noopener',
                }, options);
            }
        }
        catch (error) {
            return defaultValues;
        }
        return defaultValues;
    }, [options.href]);
};
//# sourceMappingURL=use-external-link.js.map